import { UniqueIdentifier } from '@dnd-kit/core';

import { IFBmanagerTableColumn, IFBmanagerTableName } from './reducer';

export enum TablesSettingsActionTypes {
  SET_HIDDEN_COLUMNS = 'SET_HIDDEN_COLUMNS',
  ADD_HIDDEN_COLUMN = 'ADD_HIDDEN_COLUMN',
  REMOVE_HIDDEN_COLUMN = 'REMOVE_HIDDEN_COLUMN',
  SET_ACTIVE_COLUMNS_ORDER = 'SET_ACTIVE_COLUMNS_ORDER',
  REMOVE_ACTIVE_COLUMN = 'REMOVE_ACTIVE_COLUMN',
  RESET_STATE = 'RESET_STATE',
}

interface ISetHiddenColumnsAction {
  type: TablesSettingsActionTypes.SET_HIDDEN_COLUMNS;
  payload: {
    tableName: IFBmanagerTableName;
    columns: IFBmanagerTableColumn[];
  };
}

interface IAddHiddenColumnAction {
  type: TablesSettingsActionTypes.ADD_HIDDEN_COLUMN;
  payload: {
    tableName: IFBmanagerTableName;
    column: IFBmanagerTableColumn;
  };
}

interface IRemoveHiddenColumnAction {
  type: TablesSettingsActionTypes.REMOVE_HIDDEN_COLUMN;
  payload: {
    tableName: IFBmanagerTableName;
    column: IFBmanagerTableColumn;
  };
}

interface ISetActiveColumnsOrderAction {
  type: TablesSettingsActionTypes.SET_ACTIVE_COLUMNS_ORDER;
  payload: {
    tableName: IFBmanagerTableName;
    activeId: UniqueIdentifier;
    overId: UniqueIdentifier | null;
  };
}

interface IRemoveActiveColumnAction {
  type: TablesSettingsActionTypes.REMOVE_ACTIVE_COLUMN;
  payload: {
    tableName: IFBmanagerTableName;
    column: IFBmanagerTableColumn;
  };
}

interface IResetStateAction {
  type: TablesSettingsActionTypes.RESET_STATE;
  payload: {
    tableName: IFBmanagerTableName;
  };
}

export type TTablesSettingsActions =
  | ISetHiddenColumnsAction
  | IAddHiddenColumnAction
  | IRemoveHiddenColumnAction
  | ISetActiveColumnsOrderAction
  | IRemoveActiveColumnAction
  | IResetStateAction;

export const setHiddenColumns = (payload: ISetHiddenColumnsAction['payload']): TTablesSettingsActions => ({
  type: TablesSettingsActionTypes.SET_HIDDEN_COLUMNS,
  payload,
});

export const addHiddenColumn = (payload: IAddHiddenColumnAction['payload']): TTablesSettingsActions => ({
  type: TablesSettingsActionTypes.ADD_HIDDEN_COLUMN,
  payload,
});

export const removeHiddenColumn = (
  payload: IRemoveHiddenColumnAction['payload']
): TTablesSettingsActions => ({
  type: TablesSettingsActionTypes.REMOVE_HIDDEN_COLUMN,
  payload,
});

export const setActiveColumnsOrder = (
  payload: ISetActiveColumnsOrderAction['payload']
): TTablesSettingsActions => ({
  type: TablesSettingsActionTypes.SET_ACTIVE_COLUMNS_ORDER,
  payload,
});

export const removeActiveColumn = (
  payload: IRemoveActiveColumnAction['payload']
): TTablesSettingsActions => ({
  type: TablesSettingsActionTypes.REMOVE_ACTIVE_COLUMN,
  payload,
});

export const resetTablesSettingsState = (payload: IResetStateAction['payload']): TTablesSettingsActions => ({
  type: TablesSettingsActionTypes.RESET_STATE,
  payload,
});
